/* global axios */

import ApiClient from './ApiClient';

class TaccRelatedContactsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  relatedUrl(conversationId) {
    return `${this.url}/${conversationId}/tacc_related_contacts`;
  }

  syncUrl(conversationId) {
    return `${this.url}/${conversationId}/tacc_related_contact_sync`;
  }

  getRelatedContacts(conversationId) {
    return axios.get(this.relatedUrl(conversationId), {
      headers: { 'Cache-Control': 'no-cache' },
    });
  }

  syncMessage(conversationId, payload) {
    return axios.post(this.syncUrl(conversationId), payload);
  }
}

export default new TaccRelatedContactsAPI();
